import { AccomodationEnum } from '../../types/enums/accomodation-type/accomodation-type'
import { BudgetAllocationFilters } from '../../types/models/budget-line/budget-line-filter'

export const transformBudgetAllocationFiltersToUrl = (
  filters?: BudgetAllocationFilters
): string => {
  if (!filters) return ''
  const searchParams = new URLSearchParams()

  if (filters.centerIds && filters.centerIds.length)
    searchParams.append('centerIds', filters.centerIds.join(','))
  if (filters.radIds && filters.radIds.length)
    searchParams.append('radIds', filters.radIds.join(','))
  if (filters.radDate) searchParams.append('radDate', filters.radDate)
  if (filters.periodIds && filters.periodIds.length)
    searchParams.append('periodIds', filters.periodIds.join(','))
  if (filters.countryIds && filters.countryIds.length)
    searchParams.append('countryIds', filters.countryIds.join(','))
  if (filters.accomodations && filters.accomodations.length)
    searchParams.append('accomodations', filters.accomodations.join(','))

  return searchParams.toString()
}

export const transformUrlToBudgetAllocationFilters = (
  searchParams: URLSearchParams
): BudgetAllocationFilters => {
  const filters: BudgetAllocationFilters = {}

  const centerIds = searchParams.get('centerIds')
  if (centerIds) filters.centerIds = centerIds.split(',').map(Number)

  const radIds = searchParams.get('radIds')
  if (radIds) filters.radIds = radIds.split(',').map(Number)

  const radDate = searchParams.get('radDate')
  if (radDate) filters.radDate = radDate

  const periodIds = searchParams.get('periodIds')
  if (periodIds) filters.periodIds = periodIds.split(',').map(Number)

  const countryIds = searchParams.get('countryIds')
  if (countryIds) filters.countryIds = countryIds.split(',').map(Number)

  const accomodations = searchParams.get('accomodations')
  if (accomodations) filters.accomodations = accomodations.split(',') as AccomodationEnum[]

  return filters
}
